import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fade, Typography, makeStyles } from '@material-ui/core';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';
import { getItemById } from '../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: primary.bluish9,
    boxSizing: 'border-box',
    position: 'sticky',
    left: 0,
    padding: spacing(4, 4, 4, 0),
    minHeight: 84,
    zIndex: 99,
    '&::after': {
      backgroundColor: primary.bluish9,
      content: '""',
      position: 'absolute',
      top: 0,
      right: -8,
      width: 8,
      height: '100%',
    },
  },
  question: {
    wordBreak: 'break-word',
  },
  commentsWrapper: {
    float: 'right',
  },
  averageScore: {
    width: 'fit-content',
    marginTop: spacing(2),
  },
}));

const Question = ({
  translations,
  question,
  reviewComments = [],
  hasAverageScore,
  shouldShowQuestionScore = false,
  questionAverage,
  onViewQuestionComments = () => {},
}) => {
  const classes = useStyles();
  const { text, id } = question;
  const hasAnswerComments = !!getItemById(reviewComments, id);

  const onViewComments = () => onViewQuestionComments(question.id);

  return (
    <div className={classes.root}>
      <div className={classes.commentsWrapper}>
        <Fade in={hasAnswerComments} unmountOnExit>
          <div>
            <ActionButton
              type={ACTION_BUTTON_TYPES.EDIT_COMMENT}
              tooltipText={translations.viewComments}
              onClickHandler={onViewComments}
              hasBorder
            />
          </div>
        </Fade>
      </div>
      <Typography className={classes.question} variant="body2">
        {text}
      </Typography>
      {shouldShowQuestionScore && hasAverageScore && (
        <Typography
          component="div"
          variant="subtitle2"
          className={classNames(classes.averageScore)}
        >
          {`${translations.questionScore} ${questionAverage}`}
        </Typography>
      )}
    </div>
  );
};

Question.propTypes = {
  hasAverageScore: PropTypes.bool.isRequired,
  shouldShowQuestionScore: PropTypes.bool,
  translations: PropTypes.object.isRequired,
  question: PropTypes.shape({}).isRequired,
  questionAverage: PropTypes.number.isRequired,
  reviewComments: PropTypes.arrayOf(PropTypes.object),
  onViewQuestionComments: PropTypes.func,
};

export default Question;
